import {
  defaultColumnProps,
  defaultGridProps,
  getGridStyles
} from 'utils/mui-components/data-grid-utils'

export const sharedColumnProps = {
  ...defaultColumnProps,
  disableColumnMenu: true,
  disableReorder: true,
  field: 'name',
  filterable: false,
  flex: 2,
  headerName: 'Results',
  sortable: false
}

export const sharedGridProps = {
  ...defaultGridProps,
  hideFooterSelectedRowCount: true,
  pageSize: 10,
  rowsPerPageOptions: [10],
  getRowHeight: () => 'auto' as const,
  sx: getGridStyles({
    clickableRow: true
  })
}
